import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { IInfoTable, IInfoTableCriteria, IInfoTableRow } from "@tylertech/tyler-api-types";
import { InfoTableCommandArgs } from "../../interfaces";
import { EditDialogData } from "../edit";
import { EditRowArgs } from "../grid";

import { IInfoTableOptions } from "../infoTableOptions";
import { Observable } from "rxjs";

export interface InfoTableDialogData extends IInfoTableOptions
{
    readonly criteria: IInfoTableCriteria;
}

@Component({
    selector: "info-table-dialog-component",
    templateUrl: "./infoTableDialog.tmpl.html",
    styleUrls: [
        "./infoTableDialog.component.scss"
    ],
    standalone: false
})

export class InfoTableDialogComponent implements OnInit
{
    tableData: IInfoTable;

    constructor(
        private readonly dialogRef: MatDialogRef<InfoTableDialogComponent, Array<IInfoTableRow> | undefined>,
        @Inject(MAT_DIALOG_DATA) private readonly data: InfoTableDialogData
    ) { }

    get criteria(): IInfoTableCriteria { return this.data.criteria; }
    get displayHeader(): boolean { return this.data.displayHeader; }
    get displayTable(): boolean { return this.data.displayTable; }
    get ignoreNumbers(): boolean { return this.data.ignoreNumbers; }
    get noFilter(): boolean { return this.data.noFilter; }
    get rowsPerPage(): number { return this.data.rowsPerPage; }
    get dialogClass(): string { return this.data.cssClass || ""; }

    ngOnInit(): void
    {
        this.dialogRef.updateSize("60vw", "60vh");
    }

    clientAction($event: InfoTableCommandArgs): void
    {
        this.dialogRef.close($event.rows);
    }

    onCloseClicked(): void
    {
        this.dialogRef.close();
    }
}
